import { Map, fromJS } from 'immutable'
import _toNumber from 'lodash/toNumber'
import * as actions from './actions'

export const initialState = Map()

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case actions.SET_PAYMENT_METHODS_PROCESSING:
      return state
        .set('paymentMethodsProcessing', action.payload)
    case actions.SET_PAYMENT_METHODS:
      return state
        .setIn(['data', 'paymentMethods'], fromJS(action.payload.data))
        .set('paymentMethodsProcessing', action.payload.processing)
    case actions.RESET_PAYMENT_METHODS:
      return state
        .deleteIn(['data', 'paymentMethods'])
    case actions.SET_PAYMENT_DATA_PROCESSING:
      return state
        .set('paymentDataProcessing', action.payload)
    case actions.SET_PAYMENT_DATA:
      return state
        .setIn(['data', 'payments'], fromJS(action.payload.data))
        .set('paymentDataProcessing', action.payload.processing)
    case actions.SET_PAYMENT_ERROR:
      return state
        .set('error', action.payload.error)
        .set('paymentDataProcessing', action.payload.processing)
    case actions.RESET_PAYMENT_DATA:
      return state
        .deleteIn(['data', 'payments', 'error'])
        .deleteIn(['data', 'payments', 'success'])
        .deleteIn(['data', 'payments', 'data'])
    case actions.RESET_PAYMENT_ERROR:
      return state
        .delete('error')
    case actions.SET_PAYMENT_CAPTCHA_VALID:
      return state
        .setIn(['data', 'captcha', 'valid'], action.payload)
    case actions.SET_PAYMENT_TEST_CODE:
      return state
        .setIn(['data', 'testResultCode'], _toNumber(action.payload))
    case actions.RESET_PAYMENT_TEST_CODE:
      return state
        .deleteIn(['data', 'testResultCode'])
    case actions.SET_PAYMENT_AUTHORIZATION:
      return state
        .setIn(['data', 'payments', 'authorization'], fromJS(action.payload))
    case actions.SET_PAYMENT_BILLING_INFO:
      return state
        .setIn(['data', 'billingInfo'], fromJS(action.payload))
    default:
      return state
  }
}
